import type { ModuleKey } from '@fos/shared/enums';
import type { AddDialogKind } from '../../../app/layout/nav';
import { useShell } from '../../../app/layout/shell-context';
import { cn } from '../../../lib/cn';
import { useAccess } from '../../../lib/useAccess';
import { Button } from '../../../ui/Button';

/**
 * „Wpisz ręcznie: czas · zadanie · notatka” (10.10.2026, DECISIONS [S] „Mikrofon w dolnym menu = Copilot”): ręczne
 * formularze modułów (AddDialogs) pod polem czatu, gdy panel otwarto mikrofonem z dolnego menu albo AI jest
 * niedostępne — podstawowa czynność działa bez AI. Tylko moduły z Edycją; klik zamyka czat i otwiera formularz.
 */

const SHORTCUTS: readonly {
  kind: Extract<AddDialogKind, 'time' | 'task' | 'note'>;
  label: string;
  module: ModuleKey;
}[] = [
  { kind: 'time', label: 'czas', module: 'time' },
  { kind: 'task', label: 'zadanie', module: 'tasks' },
  { kind: 'note', label: 'notatka', module: 'knowledge' },
];

export function ManualShortcuts({ onOpen, className }: { onOpen: () => void; className?: string }) {
  const access = useAccess();
  const shell = useShell();
  const allowed = SHORTCUTS.filter((s) => access.can(s.module, 'edit'));
  if (allowed.length === 0) return null;
  return (
    <div className={cn('flex flex-wrap items-center gap-x-0.5 text-caption text-fg-muted', className)}>
      <span className="mr-1">Wpisz ręcznie:</span>
      {allowed.map((s) => (
        <Button
          key={s.kind}
          variant="ghost"
          size="s"
          className="h-9 px-2"
          onClick={() => {
            onOpen();
            shell.openAddDialog(s.kind);
          }}
        >
          {s.label}
        </Button>
      ))}
    </div>
  );
}
